import React from "react";
import { EXPERIENCES } from "@/lib/data";
import { MapPin } from "lucide-react";

export default function Experiences() {
  return (
    <section
      id="experiences"
      data-testid="experiences-section"
      className="bg-mrn-cream py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.3em] text-mrn-terracotta font-medium">
              Around Nandi
            </p>
            <h2 className="mt-4 headline-display text-4xl md:text-6xl text-mrn-wood">
              Nearby experiences, <br />
              <em className="font-light text-mrn-green">minutes away.</em>
            </h2>
          </div>
          <p className="max-w-sm text-mrn-wood-soft text-sm">
            From a pre-dawn sunrise at Nandi Hills to a quiet visit to the Isha
            Foundation — every weekend plan starts from your doorstep.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {EXPERIENCES.map((e, i) => (
            <article
              key={e.title}
              data-testid={`experience-${i}`}
              className="group overflow-hidden rounded-2xl bg-white border border-mrn-sand-dark/30"
            >
              <div className="overflow-hidden">
                <img
                  src={e.image}
                  alt={e.title}
                  loading="lazy"
                  className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-mrn-terracotta font-medium">
                  <MapPin size={14} strokeWidth={1.8} />
                  {e.distance}
                </div>
                <h3 className="mt-3 font-display text-2xl text-mrn-wood">{e.title}</h3>
                <p className="mt-2 text-sm text-mrn-wood-soft leading-relaxed">{e.blurb}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
